import React, { useState } from 'react';
import { Modal, Button, Tooltip } from 'antd';

import { LicenseCreateFormContainer } from '../../containers';

import styles from './LicenseTable.module.scss';

const LicenseCreateModal = props => {
  const [visible, setVisible] = useState(false);
  const { ValidDays } = props;

  const showModal = () => setVisible(true);
  const handleCancel = () => setVisible(false);

  return (
    <div>
      {ValidDays ? (
        <Tooltip title="Create new license request based on its details">
          <Button className={styles.actionButton} onClick={showModal}>
            Clone
          </Button>
        </Tooltip>
      ) : (
        <Button type="primary" onClick={showModal}>
          Create License
        </Button>
      )}
      <Modal
        title="License Creation Form"
        width={750}
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose={true}
      >
        <LicenseCreateFormContainer {...props} closeModal={handleCancel} />
      </Modal>
    </div>
  );
};

export default LicenseCreateModal;
